import { useState, useEffect } from "react"

import { GetAddressesResponse } from "@lib/clients/nelo-api-client"
import { neloApiClient } from "@lib/config-client"

export const useGetUserAddresses = (isInitialized: boolean) => {
  const [addresses, setAddresses] = useState<GetAddressesResponse | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [isAddressSet, setIsAddressSet] = useState<boolean>(false)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    if (!isInitialized) return

    const fetchAddresses = async () => {
      setIsLoading(true)
      setError(null)
      try {
        const response = await neloApiClient.getUserAddresses()
        setAddresses(response)
        setIsAddressSet(true)
      } catch (err) {
        setError(err instanceof Error ? err : new Error("An unknown error occurred"))
        console.error("Error fetching user addresses:", err)
      } finally {
        setIsLoading(false)
      }
    }

    fetchAddresses()
  }, [isInitialized])

  return { addresses, isLoading, error, isAddressSet }
}
